import { axios, def, handleError, authencated } from './internal';

function Login(
    configHash,
    email,
    password,
    service,
    onSuccess,
    onFailed,
    onBlocked,
    onInactive,
    onMfaRequired,
    onUnauthorized,
) {
    axios
        .post('/api/login', { configHash, email, password, service })
        .then((res) => {
            if (res.data.code === def.ErrorCode.LOGIN_MFA_REQUIRED) {
                onMfaRequired();
                return;
            }
            authencated(res.data.data);
            onSuccess();
        })
        .catch((err) => {
            const { status, data } = err.response || {};
            switch (status) {
                case def.StatusCodes.UNAUTHORIZED:
                    onFailed();
                    break;
                case def.StatusCodes.TOO_MANY_REQUESTS:
                    onFailed();
                    break;
                case def.StatusCodes.FORBIDDEN:
                    switch (data?.code) {
                        case def.ErrorCode.AUTH_INSUFFICIENT_PERMISSION:
                            onUnauthorized();
                            break;
                        case def.ErrorCode.LOGIN_BLOCKED_USER:
                            onBlocked(new Date(data.data?.expire));
                            break;
                        case def.ErrorCode.LOGIN_INACTIVE_USER:
                            onInactive();
                            break;
                        default:
                            handleError(err);
                            break;
                    }
                    break;
                default:
                    handleError(err);
                    break;
            }
        });
}

export { Login };
